<div  *ngIf="isLoading | async" class="overlay">
    <svg class="loader" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
    </svg>
    <p class="loading-text">Loading...</p>
  </div>

